import moment from "moment";

export const tabs = [
  { title: "Collections Detail", value: "1" },
  { title: "School Detail Report", value: "2" },
];

export const tableData = [
  {
    name: "North",
    comments: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
  {
    name: "North",
    comments: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
  {
    name: "North",
    comments: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: false,
  },
  {
    name: "North",
    comments: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
  {
    name: "North",
    comments: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
  {
    name: "North",
    comments: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
  {
    name: "North",
    comments: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
  {
    name: "North",
    comments: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
  {
    name: "North",
    comments: "Reference site about Lorem Ipsum, giving...",
    createdAt: moment(),
    active: true,
  },
];
